import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencySymbol'
})
export class CurrencySymPipe implements PipeTransform {

  transform(currency: string): string {
    switch (currency) {
      case 'EUR':
        return '€';
      case 'USD':
        return '$';
      case 'GBP':
        return '£';
      case 'AUD':
        return 'A$';
      case 'CAD':
        return 'C$';
      case 'JPY':
        return '¥';
      case 'CNY':
        return 'CN¥';
      case 'BRL':
        return 'R$';
      case 'SEK':
        return 'kr';
      default:
        return '£';
    }
  }
}
